import React, { useState, useEffect } from 'react'
import {
  Datagrid,
  TextField,
  useTranslate,
  Pagination,
  ListContextProvider,
  useList,
  TextInput,
  BooleanInput,
  ResourceContextProvider,
  TopToolbar,
  useDataProvider,
  ListToolbar,
  SelectInput,
  useNotify,
  useRecordContext,
  DateInput
} from 'react-admin'
import { reservationServices } from 'src/services/sales/reservation/reservation.service'
import { FormattedTextFieldWithStatus } from '../sales/reservation/helper/FormattedTextFieldWithStatus'
import { PENDING, PENDING_BILLING } from '../sales/reservation/logic/common/state'
import { Button, Dialog, DialogContent, DialogTitle, Skeleton } from '@mui/material'
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { ListViewTopToolbar } from 'src/components/uiElements/CRUD/ListViewTopToolbar'
import { Visibility } from '@mui/icons-material'
import { HasPermission } from 'src/helper/HasPermission'
import ReactJson from 'react-json-view'
import CloseIcon from '@mui/icons-material/Close';

const ShowJsonButton = () => {
  const translate = useTranslate()
  const record = useRecordContext();
  const [openDialog, setOpenDialog] = useState(false)
  const [jsonData, setJsonData] = useState({})
  const [isLoading, setIsLoading] = useState(false)
  if (!record) return null;

  const getTicketInfo = async () =>{
    setOpenDialog(true)
    setIsLoading(true)
    await reservationServices.getTicketInfo(Number(record.id.split('_')[0])).then(res=>{
      setJsonData(res.data.xml_response)
    }).finally(()=>{
      setIsLoading(false)
    })
  }

  return (
    <>
      <Visibility
        color="primary"
        fontSize="small"
        style={{ cursor: 'pointer' }}
        onClick={getTicketInfo}
      />
      <Dialog open={openDialog} onClose={()=>setOpenDialog(false)}>
        <DialogTitle>
          <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between'}}>
            {translate('ra.field.json')}
            <CloseIcon onClick={()=>setOpenDialog(false)} style={{cursor:'pointer'}}/>
          </div>
        </DialogTitle>
        <DialogContent>
          {
            isLoading ?
            <Skeleton width={200}/>:
            <ReactJson
              src={jsonData}
              /* theme="monokai" */
              collapsed={2} 
              enableClipboard={(copy) => {
                try {
                  navigator.clipboard.writeText(JSON.stringify(copy.src));
                } catch (e) {
                }
              }}
              displayDataTypes={false}
            />
          }
        </DialogContent>
      </Dialog>
    </>
  );
};

function AirStarlingsTicketsList({ loading }) {
  const notify = useNotify()
  const translate = useTranslate()
  const [isLoading, setIsLoading] = useState(false)
  const [filter, setFilter] = useState({})
  const [displayedFilters, setDisplayedFilters] = useState({})
  const [pagination, setPagination] = useState({ page: 1, perPage: 10 })
  const [airStarlingsTickets, setAirStarlingsTickets] = useState([])
  const [timeoutFilters, setTimeoutFilters] = useState()
  const [total, setTotal] = useState(0)
  /* const [exportData, setExportData] = useState([]) */
  const [loadingExport, setLoadingExport] = useState(false)

  useEffect(() => {
    getAirStarlingsTickets()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter, pagination, loading])

  const onExport = async () =>{
    setLoadingExport(true)
    try{
      const params = {
        order_by: '-id',
        skip: 0,
        limit: 1000,
        ...filter,
      }
      await reservationServices.exportAirStarlingsTickets(params).then(()=>{
        notify('ra.message.export_success', {type:'success', messageArgs:{email:JSON.parse(localStorage.getItem('user'))?.email}})
      })
      .finally(()=>{
        setLoadingExport(false)
      })
    /* const params = {
        order_by: '-id',
        skip: 1,
        limit: 1000,
        ...filter,
      }
      const airTicketsAux = await reservationServices.getAirStarlingsTickets(params)
      if (airTicketsAux) {
        setExportData(airTicketsAux.data)
      } else {
        setExportData([])
      } */
    } catch (error) {
      /* setExportData([]) */
      notify('ra.message.export_error',{type:'error'})
    }
  }

  /* useEffect(()=>{
    if(exportData.length > 0){
      handleExport()
    }
    setLoadingExport(false)
  },[exportData]) */

  const getAirStarlingsTickets = async () => {
    try {
      setIsLoading(true)
      const params = {
        order_by: '-id',
        skip: (pagination.page - 1) * pagination.perPage,
        limit: pagination.perPage,
        ...filter,
      }
      const airTicketsAux = await reservationServices.getAirStarlingsTickets(params)
      if (airTicketsAux) {
        setAirStarlingsTickets(airTicketsAux.data.map(item=>{return {...item, id: `${item.id}_${item.rownum}`}}))
        setTotal(airTicketsAux.total)
        setIsLoading(false)
      } else {
        setAirStarlingsTickets([])
        setIsLoading(false)
      }
    } catch (error) {
      setIsLoading(false)
      setAirStarlingsTickets([])
    }
  }

  const listContext = useList({
    data: airStarlingsTickets,
    resource: 'air-import',
    isLoading,
    sort: { field: 'id', order: 'DESC' },
    displayedFilters: displayedFilters,
    filterValues: filter,
    ...pagination,
  })
  /* const handleExport = async () => {
    try {

      jsonExport(
        exportData,
        {
          delimiter: ';', // ← CLAVE para Excel en español
          includeHeaders: true,
        },
        (err, csv) => {
          if (err) {
            console.error('Error exporting:', err);
            return;
          }

          // Agregamos BOM y forzamos UTF-8
          const blob = new Blob(['\uFEFF' + csv], {
            type: 'text/csv;charset=utf-8;',
          });

          const link = document.createElement('a');
          link.href = URL.createObjectURL(blob);
          link.setAttribute('download', 'air_import.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          setExportData([])
        }
      );
      setLoadingExport(false)
    } catch (e) {
      console.error('Export failed:', e);
      setExportData([])
      setLoadingExport(false)
    }
  }; */

  const onShowFilter = (filterName) => {
    setDisplayedFilters((displayedFilters) => ({
      ...displayedFilters,
      [filterName]: true,
    }))
  }

  const onHideFilter = (filterName) => {
    const displayedFiltersAux = { ...displayedFilters }
    delete displayedFiltersAux[filterName]
    setDisplayedFilters(displayedFiltersAux)
    const filterAux = { ...filter }
    delete filterAux[filterName]

    if (JSON.stringify(filter) !== JSON.stringify(filterAux)) {
      setFilter(filterAux)
    }
  }

  const onChangeFilters = (filters, displayedFiltersAux) => {
    setDisplayedFilters(displayedFiltersAux)

    clearTimeout(timeoutFilters)
    const timeout = setTimeout(() => {
      Object.entries(filters).forEach((elem) => {
        const [key, value] = elem
        if (value === null) {
          delete filters[key]
        }
      })

      if (JSON.stringify(filter) !== JSON.stringify(filters)) {
        setFilter(filters)
      }
      onChangePagination('page', 1)
    }, 1000)
    setTimeoutFilters(timeout)
  }

  const onChangePagination = (field, value) => {
    if (pagination[field] !== value) {
      setPagination((current) => ({
        ...current,
        [field]: value,
      }))
      setAirStarlingsTickets([])
    }
  }

  const AirTicketsFilters = [
    <BooleanInput label={translate('ra.field.in_reserve')} source='is_imported' defaultValue={false} />,
    <TextInput label={translate('ra.field.pnr')} source='pnr_code' defaultValue='' />,
    <TextInput label={translate('ra.field.gds')} source='gds' defaultValue='' />,
    <TextInput label={translate('ra.field.item_ticket_number')} source='pax_item__ticket_number__in' defaultValue='' />,
    <TextInput label={translate('ra.field.passenger')} source='passenger' defaultValue='' />,
    <TextInput
      label={translate('ra.field.reservation_number')}
      source='reservation__number__ilike'
      defaultValue=''
    />,
    <SelectInput
      label={translate('ra.field.token')}
      source='token'
      fullWidth
      choices={[
        { id: 'GTR USD', name: 'GTR USD' },
        { id: 'GTR ARS', name: 'GTR ARS' },
        { id: 'CONEXT USD', name: 'CONEXT USD' },
      ]}
    />,
    <DateInput
      label={translate('ra.field.date_emision')}
      source='ticketing_date'
      fullWidth
      defaultValue=''
    />
  ]

  return (
    <ListContextProvider
      key={`${pagination.page}-${JSON.stringify(filter)}-${airStarlingsTickets.length}`}
      value={{
        ...listContext,
        filterValues: filter,
        displayedFilters: displayedFilters,
        setFilters: onChangeFilters,
        showFilter: onShowFilter,
        hideFilter: onHideFilter,
      }}
    >
      {/* <ListToolbar actions={<ListViewTopToolbar/>} filters={AirTicketsFilters} /> */}
      <TopToolbar>
        <ListToolbar 
         actions={
         <ListViewTopToolbar 
          exporterDisable
          CustomExportButton={()=>(
            <Button
              sx={{ lineHeight: '1.5'}}
              size='small'
              startIcon={<FileDownloadIcon />}
              onClick={onExport}
              disabled={listContext.isLoading || loadingExport}
            >
            Exportar
          </Button>
         )
        }
        />} 
        filters={AirTicketsFilters} />
        
        {/* <ExportButton/> */}
      </TopToolbar>
      <Datagrid isLoading={isLoading} bulkActionButtons={null}>
        <FormattedTextFieldWithStatus
          label={translate('ra.field.status')}
          source='status'
          sortable={false}
          getValue={(value) => (value === PENDING ? PENDING_BILLING : value)}
        />
        <TextField label={translate('ra.field.pnr')} source='pnr_code' sortable={false} />
        <TextField label={translate('ra.field.gds')} source='gds' sortable={false} />
        <TextField label={translate('ra.field.ticket_number')} source='ticket_number' sortable={false} />,
        <TextField label={translate('ra.field.ticket_type')} source='ticket_type' sortable={false} />,
        <TextField label={translate('ra.field.date_emision')} source='ticketing_date' sortable={false} />,
        <TextField label={translate('ra.field.passenger')} source='passenger' sortable={false} />
        <TextField label={translate('ra.field.reservation_number')} source='number' sortable={false} />
        <TextField label={translate('ra.field.token')} source='token' sortable={false} />
        <HasPermission permission='show' resource={'air-import'}>
          <ShowJsonButton/>
        </HasPermission>
      </Datagrid>
      <Pagination
        {...pagination}
        total={total}
        isLoading={isLoading}
        setPage={(value) => onChangePagination('page', value)}
        setPerPage={(value) => onChangePagination('perPage', value)}
      />
    </ListContextProvider>
  )
}

export default AirStarlingsTicketsList
